// Source files route (/admin/datasets/files): text and unregistered-only filters in the URL; the screen is FilesPage with the paused uploads of this browser.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { optionalBoolean, optionalString } from "@/app/search";
import { FilesPage } from "@/features/datasets/FilesPage";

const searchSchema = z.object({
  q: optionalString(),
  unregistered: optionalBoolean(),
});

export const Route = createFileRoute("/_app/admin/datasets/files")({
  validateSearch: searchSchema,
  staticData: { crumb: "Files" },
  component: FilesPage,
});
